import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';

const useBloomreachSiteLogos = ()=>{
    const page = useBrPageContext();
    const models = page === null || page === void 0 ? void 0 : page.getComponent().getModels();
    if (!models) {
        return {};
    }
    return {
        main: models.logoUrl,
        small: models.logoSmallUrl,
        mobile: models.logoMobileUrl,
        alternative: models.logoAlternativeUrl,
        reimbursable: models.reimbursableLogoUrl,
        reimbursableAlternative: models.reimbursableLogoAlternativeUrl,
        payInstallmentsLogo: models.payInstallmentsLogoUrl,
        logoFooter: models.logoFooter
    };
};

export { useBloomreachSiteLogos };
//# sourceMappingURL=use-bloomreach-site-logos.js.map
